import * as __model from '../model';



export class modifiedProperties extends String{ 
}